"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
import _ from "underscore";
export default class Refetcher {
  constructor(url, onDataReturned) {
    __publicField(this, "url");
    __publicField(this, "onDataReturned");
    __publicField(this, "_lastUpdatedAt");
    this.url = url;
    this.onDataReturned = onDataReturned;
  }
  update() {
    return $.ajax({
      url: this.url,
      type: "get",
      data: { since: this._lastUpdatedAt },
      cache: false
    }).then((data) => {
      var items = this.onDataReturned(data);
      if (items && items.length > 0) {
        var updated = _.map(_.pluck(items, "updated_at"), function(a) {
          return new Date(a);
        });
        this._lastUpdatedAt = _.max(updated).getTime();
      } else {
        this._lastUpdatedAt = this._lastUpdatedAt || (/* @__PURE__ */ new Date(0)).getTime();
      }
    });
  }
}
